export const ROLE_TYPES = {
  LEADER: 19,
};
